import {mapMutations, mapState} from "vuex";
import {hasAccess} from '@/utils/Auth'

export default {
    computed: {
        ...mapState(['currentUser', 'currentProvider', 'isDark']),
        user() {
            const vm = this
            let items = [
                {title: 'Dashboard', icon: 'mdi-home', link: {name: 'panel.dashboard'}},
            ]

            if (vm.currentUser && !vm.currentProvider && vm.isOnBoardingDone) {
                items = [
                    ...items,
                    /*{title: 'Presupuestos', icon: 'fa-calculator', link: {name: 'panel.user.quotation_requests'}},
                    {title: 'Promociones', icon: 'fas fa-piggy-bank', link: {name: 'panel.user.special_sales'}},*/
                    {title: 'Mis Citas', icon: 'mdi-calendar', link: {name: 'panel.user.appointments'}}
                ]
            }

            return items

        },
        provider() {
            const vm = this
            return [
                // { title: 'Datos Proveedor', icon: 'fa-user', link: {name: 'panel.provider.info'} },
                {title: 'Recepción', icon: 'mdi-account-arrow-right', link: {name: 'panel.provider.appointments'}},
                {title: `Atención`, icon: 'mdi-door-open', link: {name: 'panel.provider.specialist_daily_schedule'}},
                {title: vm.clientPlural, icon: 'mdi-account-group', link: {name: 'panel.provider.clients'}},
                {title: 'Galería', icon: 'mdi-image-multiple', link: {name: 'panel.provider.gallery'}},
                {title: 'Presupuestos', icon: 'fa-calculator', link: {name: 'panel.provider.quotations'}},
                {title: 'Solicitudes', icon: 'fa-ticket-alt', link: {name: 'panel.provider.quotation_requests'}},
            ]
        },
        configs(){
            return [
                {title: 'Mis Datos', icon: 'mdi-account', link: {name: 'panel.user.info'}},
                {title: 'Mis agendas', icon: 'mdi-calendar', link: {name: 'panel.provider.my_schedules'}},
                {title: 'Agendas', icon: 'mdi-calendar', link: {name: 'panel.provider.schedule'}},
                {title: 'Sucursales', icon: 'mdi-office-building', link: {name: 'panel.provider.branches'}},
                {title: 'Servicios', icon: 'mdi-briefcase', link: {name: 'panel.provider.services'}},
                {title: 'Miembros', icon: 'mdi-account-network', link: {name: 'panel.provider.members'}},
                {title: 'Mas', icon: 'mdi-cogs', link: {name: 'panel.provider.settings'}},
            ]
        },
        superAdmin() {
            return [
                {title: 'Planes', icon: 'fas fa-receipt', link: {name: 'panel.super.plans'}},
                {title: 'Cupones', icon: 'fas fa-ticket-alt', link: {name: 'panel.super.coupons'}},
                {title: 'Cuentas', icon: 'fas fa-user-circle', link: {name: 'panel.super.accounts'}},
            ]
        },
        providerItems() {
            var vm = this
            var providerMap = vm.provider.map(item => {

                if (item.children) {
                    item.children = item.children.filter(subItem => {
                        return hasAccess(subItem.link.name)
                    })
                    if (item.children.length === 0) return null
                }

                return item

            })

            return providerMap.filter(item => {

                if (item === null) return false

                if (!item.children) {
                    return hasAccess(item.link.name)
                }

                return true
            })
        },
        userItems() {
            var vm = this
            return vm.user.filter(item => vm.hasAccess(item.link.name))
        },
        superItems() {
            var vm = this
            return vm.superAdmin.filter(item => vm.hasAccess(item.link.name))
        },
        userConfigs(){
            const vm = this
            return vm.configs.filter(item => vm.hasAccess(item.link.name) )
        },
        allItems(){
            const vm = this
            return [
                {title: 'Usuario', icon: 'mdi-account', items: vm.userItems},
                {title: 'Producción', icon: 'mdi-build', items: vm.providerItems},
                {title: 'Configuraciones', icon: 'mdi-account', items: vm.userConfigs},
                {title: 'Admin', icon: 'mdi-account', items: vm.superItems},
            ].filter(section => section.items.length > 0)
        }
    },
    methods: {
        ...mapMutations(['setLogoutVisibility', 'blurWrapper']),
        goTo(route) {
            console.log('drawer route', route)
            const vm = this
            vm.$router.push(route)
            vm.drawer = false
        },
        hasAccess
    }
}